export default {
  create: 'snackbar/CREATE',
};
